import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  voucherList: {
    list: {
      data: [],
      total: 0,
    },
  },
  redemptionList: {
    list: {
      data: [],
      total: 0,
    },
  },
  redemption: {
    data: {},
  },
  voucherData: {},
  accumulateCalculationList: {
    list: {
      data: [],
      total: 0,
    },
  },
  balance: '',
}

export default {
  state,
  actions,
  mutations,
  getters,
}
